import type { Control } from "react-hook-form";
import { Controller } from "react-hook-form";
import urls from "../../../../urls";
import type { Person } from "../../../../utils/backend-types";
import { CustomFormFieldWrapper } from "../../../BuildingBlocks/Forms/MantineFormFields/CustomFormFieldWrapper/CustomFormFieldWrapper";
import type { CONSUMER_FORM_FIELD_DATA } from "../ConsumerForm.constants";
import type { ConsumerFormData } from "../ConsumerForm.types";
import { ConsumerOperatorField } from "./ConsumerOperatorField/ConsumerOperatorField";

type ConsumerOperatorFormFieldProps = {
  consumerId: number;
  control: Control<ConsumerFormData>;
  personFieldData: (typeof CONSUMER_FORM_FIELD_DATA)["person"];
  persons: Array<Person>;
};

function ConsumerOperatorFormField({
  consumerId,
  control,
  personFieldData,
  persons
}: ConsumerOperatorFormFieldProps) {
  return (
    <Controller
      control={control}
      name="person"
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <CustomFormFieldWrapper
          error={error}
          helpText={personFieldData?.helpText}
          label={personFieldData?.label}
          required={personFieldData?.required}
        >
          <ConsumerOperatorField
            confirmationCheckUrl={urls.api.operationPeriodsMeteringReadingsRequired(
              consumerId
            )}
            consumerId={consumerId}
            persons={persons}
            value={value}
            onChange={onChange}
          />
        </CustomFormFieldWrapper>
      )}
    />
  );
}

export { ConsumerOperatorFormField };
